module.exports = __webpack_public_path__ + "static/img/3.275e2fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/3.png
// module id = nKzZ
// module chunks = 156